var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronForwardRtl = function SvgChevronForwardRtl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M65.467 87.068a3.286 3.286 0 0 0 4.582.004 3.13 3.13 0 0 0 .063-4.433l-.06-.06L36.82 49.954 69.986 17.42a3.13 3.13 0 0 0 .058-4.432l-.06-.06a3.287 3.287 0 0 0-4.52-.056l-.061.058-35.455 34.775a3.13 3.13 0 0 0-.06 4.43l.06.06z",
    clipRule: "evenodd"
  })));
};
export default SvgChevronForwardRtl;